import React, { useContext } from 'react';
import '../components/componentsCSS/Register.css';
import { UserContext } from '../context/UserProvider';
import { withRouter } from 'react-router-dom';

import { Button, Label } from 'reactstrap';
import BlueButton from './BlueButton';
import back from '../img/Back.png';



const Info = (props) => {

  const { handleGoogle } = useContext(UserContext);

  const loginGoogle = (e) => {
    e.preventDefault();
    handleGoogle();
    return props.history.push('/dashboard');
  };

  const emailReg = (e) => {
    e.preventDefault();
    props.history.push('/emailForm');
  };

  return (
    <div className='container'>

      <div className='bck'>
        <img src={back} alt='back' onClick={() => props.history.push('/login')} />
      </div>

      <div className='d-flex justify-content-center mt-5' >
        <img
          src='https://github.com/BrendaCarranco/laaps/blob/master/img/logoNombre.png?raw=true' alt='logo' />
      </div>


      <div className='mt-3'>
        <h1 className="text-center hi">¡HOLA!</h1>
      </div>
      <div className='benefits'>
        <h3 className="text-center info-1">Regístrate y disfruta lo mejor de Laaps</h3>
      </div>
      <Label className="container">
        <div className='row container'>
          <span class="material-icons col-3">done</span>
          <p className='col-9'>Tu auto limpio mientras tú ocupas tu tiempo en otra cosa</p>
        </div>

        <div className='row container'>
          <span class="material-icons col-3">done</span>
          <p className='col-9'>Llegamos a ti</p>
        </div>

        <div className='row container'>
          <span class="material-icons col-3">done</span>
          <p className='col-9'>Contribye al cuidado del ambiente, lavamos tu auto en seco con insumos biodegradables</p>
        </div>
      </Label>


      <div className='blue-button mt-3 container'>
        <Button size="lg" block className='button-2' onClick={loginGoogle} >Registrate con Google</Button>
      </div>

      <div className='mt-3'>
        <BlueButton label={'Registrate con tu correo electrónico'} onClick={emailReg} />
      </div>
      <div className="text-center pt-3">
        <a href='/login' >¿Ya tienes una cuenta? Inicia Sesión</a>
      </div>
    </div>


  );
};

export default withRouter(Info);